export const selectCallId = (state) => state.appState.callId;
export const selectClientCode = (state) => state.appState.clientCode
export const selectAppState = (state) => state.appState